export function toTitleCase<T extends string>(
  str: T,
  convertToLower: boolean = true,
): Capitalize<T> {
  return (convertToLower ? str.toLowerCase() : str)
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ') as Capitalize<T>;
}
